<template>
  <div class="adult-check-view adult-password">
    <div class="adult-check-page">
      <div class="wrap">
        <header class="adult-check-header">
          <div class="header-top">
            <h3 class="hd-title">성인인증</h3>
          </div>
        </header>
        <div class="ch-adult-wrap">
          <span class="adult-tag"> <Over19Icon/> </span>
          <strong class="ch-adult-title">성인 비밀번호 설정이<br>완료되었습니다.</strong>
          <p class="ch-adult-text01">성인 콘텐츠 이용이나 자녀보호 설정 시 입력해 주세요.</p>
          <span class="adult-exclamation">성인 비밀번호 설정은 Wavve TV 앱을 포함한<br>모든 기기에서 동기화됩니다.</span>
          <div class="ch-adult-btn">
            <ul>
              <li>
                <a href="#" @click.prevent="confirm" class="round-btn-purple-f">확인</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Over19Icon from '@/assets/svg/common/img-age-19-ll.svg'
import { get } from 'lodash'
export default {
  name: 'PinCodeComplete',
  components: {
    Over19Icon
  },
  methods: {
    confirm () {
      const referer = get(this.$route, 'query.referer', '/')
      this.$router.replace(referer)
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/lnb.css"></style>
<style lang="css" src="@/assets/new-css/adult.css"></style>
<style scoped>
  .adult-check-view.adult-password .ch-adult-text01 {
    margin: 0;
    letter-spacing: -0.3px;
  }
</style>
